module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.$root.isOffline) ? _c('section', [_c('div', {
    staticClass: "button-bar"
  }, [(_vm.activeTab == 'section-templates') ? _c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "to": "/templates/sections/edit/new"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Section Template")]) : _vm._e(), _vm._v(" "), (_vm.activeTab == 'report-templates') ? _c('router-link', {
    staticClass: "btn btn-success",
    attrs: {
      "to": "/templates/reports/edit/new"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Report Template")]) : _vm._e(), _vm._v(" "), (_vm.$route.params.id != 'new') ? _c('nav-tabs', {
    attrs: {
      "classes": "pull-right"
    }
  }, [_c('li', {
    class: {
      active: _vm.activeTab == 'report-templates'
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.activeTab = 'report-templates'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-address-card-o"
  }), _vm._v("\n\t\t\t\t\tReport Templates\n\t\t\t\t")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activeTab == 'section-templates'
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.activeTab = 'section-templates'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker"
  }), _vm._v("\n\t\t\t\t\tSection Templates\n\t\t\t\t")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [(_vm.activeTab == 'report-templates') ? _c('div', [_c('report-templates')], 1) : (_vm.activeTab == 'section-templates') ? _c('div', [_c('section-templates')], 1) : _vm._e()])]) : _c('page-offline-alert')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c3940c48","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Templating.vue
// module id = 306
// module chunks = 0